import { Navigate, useParams } from 'react-router-dom'
import { toStreamChannelId } from '@/lib/chat'

/**
 * Legacy route — name reveal now opens as a modal on the chat page.
 * Keep this redirect so old links still work.
 */
export function NameRevealPage() {
  const { chatId } = useParams<{ chatId: string }>()
  if (!chatId) return <Navigate to="/chat" replace />
  const channelId = toStreamChannelId(chatId)
  return <Navigate to={`/chat/${channelId}?names=1`} replace />
}
